// Renders lyrics text, turning [BEEP] markers into styled badges.
// Used on The Wave where explicit songs have profanity censored server-side.
export function CensoredLyrics({ text }: { text: string }) {
  if (!text) return null;
  // Split on [BEEP] tokens (case-insensitive) and render badges inline.
  const parts = text.split(/(\[BEEP\])/gi);
  return (
    <div className="song-lyrics">
      {parts.map((part, i) => {
        if (/^\[BEEP\]$/i.test(part)) {
          return (
            <span
              key={i}
              className="chip chip-beep"
              title="Censored on The Wave — explicit lyrics are bleeped like TV or radio."
            >
              BEEP
            </span>
          );
        }
        return <span key={i}>{part}</span>;
      })}
    </div>
  );
}
